export const policyLinks = [['policies', 'gameService'], ['privacy', 'privacy'], ['servicepolicy', 'service'], ['cookies', 'storage']];
